import { ReactElement, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiDatepicker,
  RfUiInput,
  RfUiMultiselect,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectAlumnoPracticaParse2,
  makeSelectCursosPractica,
  makeSelectCursosPracticaParse2,
  makeSelectEstadosPracticas,
  makeSelectFechaMaximaPractica,
  makeSelectFechaMinimaPractica,
  makeSelectInstructoresPracticas,
  makeSelectInstructoresPracticasParse2,
  makeSelectSociedadesParse2,
} from 'store/practicas/selectors';
import {
  makeSelectNombreInstructor,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
  makeSelectPerfilesUsuarioNombreUsuario,
} from 'store/usuarios/selectors';
import {
  getEstadosPracticaRequest,
  getFilterAlumnoPracticaRequest,
  getFilterCursoPracticaRequest,
  getInstructoresPracticasRequest,
  getSociedadesRequest,
  removePracticasFilter,
} from 'store/practicas/actions';
import { setStatePracticeSelected } from 'store/app/actions';
import {
  makeSelectDateMaxSelected,
  makeSelectDateMinSelected,
} from 'store/app/selectors';
import {
  deleteSavedPagination,
  getDefaultPracticeState,
  getDefaultStatus,
} from 'utils/practiceUtils';
import { arrayToAPI } from 'utils/listUtils';
import { language } from '../../../utils/literals';
import { RouteTypes } from 'consts';
import { useHistory } from 'react-router';
import { getTodayFinishDate, getTodayMinus15 } from 'utils/dates-validators';
import { formatDateMax } from 'utils/dateTimeUtils';
import { EstadoPractica } from 'store/practicas/types';
import {
  isMobileOnly,
  isTablet,
  useMobileOrientation,
} from 'react-device-detect';
import { perfilesAlumno } from 'utils/profilesIndex';

const selectors = createStructuredSelector({
  cursosPractica: makeSelectCursosPractica(),
  instructoresPractica: makeSelectInstructoresPracticas(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  nombreInstructor: makeSelectNombreInstructor(),
  dateMinSelected: makeSelectDateMinSelected(),
  dateMaxSelected: makeSelectDateMaxSelected(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  nombreUsuario: makeSelectPerfilesUsuarioNombreUsuario(),
  estadosPracticas: makeSelectEstadosPracticas(),
  fechaMinimaPractica: makeSelectFechaMinimaPractica(),
  fechaMaximaPractica: makeSelectFechaMaximaPractica(),
  // Remake
  estados: makeSelectEstadosPracticas(),
  cursos: makeSelectCursosPracticaParse2(),
  sociedades: makeSelectSociedadesParse2(),
  alumnos: makeSelectAlumnoPracticaParse2(),
  instructores: makeSelectInstructoresPracticasParse2(),
} as any);

const AlumnPracticeListFilter = ({
  handleSubmit,
  initValues,
}): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    nombreInstructor,
    idUsuario,
    nombreUsuario,
    fechaMinimaPractica,
    estadosPracticas,
    // Remake
    estados,
    cursos,
    sociedades,
    alumnos,
    instructores,
  } = useSelector<any, any>(selectors);

  const [savedFilterListPractice]: [any, any] =
    useState(initValues);

  const getSelectedFechaHasta = (): any => {
    if (savedFilterListPractice.savedValues === false) {
      return getTodayFinishDate();
    }
    return savedFilterListPractice.fechaFin;
  };

  const [selectedCursos, setSelectedCursos]: [any, any] = useState('');

  const getFechaDesdeListAlumn = (): number => {
    if (
      savedFilterListPractice.alumnos !== '' &&
      savedFilterListPractice.cursos !== ''
    ) {
      return fechaMinimaPractica?.FECHA_TIMESTAMP?.toString();
    } else {
      return getTodayMinus15();
    }
  };

  const [selectedSociedades, setSelectedSociedades]: [any, any] = useState('');
  const [selectedInstructores, setSelectedInstructores]: [any, any] =
    useState('');
  const [selectedFechaDesde, setSelectedFechaDesde]: [any, any] = useState(
    // fechaMinimaPractica.FECHA_TIMESTAMP
    getFechaDesdeListAlumn()
  );
  const [selectedFechaHasta, setSelectedFechaHasta]: [any, any] = useState(
    getSelectedFechaHasta()
  );
  const [selectedAlumnos, setSelectedAlumnos]: [any, any] = useState('');

  const estadosPracticasParse = useMemo(() => {
    return JSON.stringify(
      estados.map((estadoPractica: EstadoPractica) => ({
        label: estadoPractica.NOMBRE_EST_PRACTICA,
        value: estadoPractica.ID_EST_PRACTICA,
      }))
    );
  }, [estados, savedFilterListPractice.estados]);

  const newInit = {
    ...savedFilterListPractice,
    fechaInicio: getFechaDesdeListAlumn(),
  };
  const [iniFilter, setInitFilter] = useState(newInit);

  useEffect(() => {
    setInitFilter(newInit);
    filter.current = { ...newInit };
  }, [savedFilterListPractice]);

  const filter: any = useRef(null);

  useEffect(() => {
    const newCourses = JSON.parse(cursos).filter((c) => {
      return c.value.toString() === iniFilter.cursos;
    });
    setSelectedCursos(JSON.stringify(newCourses));

    const newAlumns = JSON.parse(alumnos).filter((a) => {
      return a.value.toString() === iniFilter.alumnos;
    });
    setSelectedAlumnos(JSON.stringify(newAlumns));

    const newSociety = JSON.parse(sociedades).filter((s) => {
      return s.value.toString() === iniFilter.sociedades;
    });
    setSelectedSociedades(JSON.stringify(newSociety));

    const newInstructors = JSON.parse(instructores).filter((i) => {
      return i.value.toString() === iniFilter.instructores;
    });
    setSelectedInstructores(JSON.stringify(newInstructors));
  }, []);

  const handleDateMinSelected = (e: any) => {
    setSelectedFechaDesde(e.detail);
    filter.current.fechaInicio = e.detail;
  };

  const parseDefaultStatesToString = (data: any) => {
    let res = '';
    data = JSON.parse(data);
    data.forEach((item: any) => {
      res = res === '' ? item.value : res + ',' + item.value;
    });
    return res;
  };

  let defaultPracticeState = useMemo(
    () => getDefaultPracticeState(profileActive, savedFilterListPractice),
    [profileActive, savedFilterListPractice]
  );

  useEffect(() => {
    dispatch(
      setStatePracticeSelected(parseDefaultStatesToString(defaultPracticeState))
    );
  }, [defaultPracticeState]);

  const handleDateMaxSelected = (e: any) => {
    if (filter.current) {
      setSelectedFechaHasta(formatDateMax(e.detail));
      filter.current.fechaFin = formatDateMax(e.detail);
    }
  };

  const handleStatePracticeSelected = (e: any) => {
    const estados = arrayToAPI(e.detail);
    filter.current = { ...filter.current, estados };
  };

  const handleSelectedCourse = (e: any) => {
    const cursos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, cursos };
    setSelectedAlumnos('[]');
    dispatch(
      getFilterAlumnoPracticaRequest({
        cursos,
        sociedades: filter.current.sociedades,
      })
    );
  };

  const handleSelecteSociety = (e: any) => {
    const sociedades = arrayToAPI(e.detail);
    filter.current = { ...filter.current, cursos: '', alumnos: '', sociedades };

    setSelectedCursos('[]');
    setSelectedAlumnos('[]');

    dispatch(getFilterCursoPracticaRequest({ sociedades }));
    dispatch(getFilterAlumnoPracticaRequest({ cursos: '', sociedades }));
  };

  const handleSelectedInstructor = (e: any) => {
    const instructores = arrayToAPI(e.detail);
    filter.current = { ...filter.current, instructores };
  };

  const handleStudentSelected = (e: any) => {
    const alumnos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, alumnos };
  };

  const sendToHome = (withFilters: boolean) => {
    if (withFilters) {
      const paramsToHome = {
        ...filter.current,
        savedValues: true,
      };
      deleteSavedPagination(window.location.pathname);

      sessionStorage.setItem(
        `savedFilter-${window.location.pathname}`,
        JSON.stringify(paramsToHome)
      );
    } else {
      deleteSavedPagination(window.location.pathname, true, true);
    }

    history.push(RouteTypes.HOME);
  };

  const handlerSubmitFilters = () => {
    if (
      initValues.alumnos === filter.current.alumnos &&
      initValues.cursos === filter.current.cursos
    ) {
      deleteSavedPagination(window.location.pathname);
      handleSubmit(filter.current);
    } else {
      sendToHome(true);
    }
  };

  useEffect(() => {
    if (filter.current || !profileActive) {
      handleSubmit(filter.current);
      return;
    }

    const newIniFilter = getDefaultStatus(profileActive, iniFilter);

    setInitFilter(newIniFilter);
    filter.current = { ...newIniFilter };

    filter.current.fechaInicio = getFechaDesdeListAlumn();
    setSelectedFechaDesde(getFechaDesdeListAlumn());
    setSelectedFechaHasta(getSelectedFechaHasta());
  }, [profileActive]);

  const { isLandscape } = useMobileOrientation();

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>

        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            <div>
              <div className={isTablet && isLandscape ? '' : 'rf-box__child'}>
                <div
                  className={
                    isTablet && isLandscape
                      ? 'rf-practice-list__input-container'
                      : 'rf-practice-list__input-container rf-practice-list__input-container--pr'
                  }
                >
                  {fechaMinimaPractica?.FECHA_TIMESTAMP && (
                    <RfUiDatepicker
                      position={'left'}
                      moment-locale="es"
                      labelInput="Desde"
                      text-apply-button="Aplicar"
                      defaultMinDateFrom={fechaMinimaPractica?.FECHA_TIMESTAMP?.toString()}
                      defaultMaxDateFrom={selectedFechaHasta}
                      defaultDateFrom={selectedFechaDesde}
                      onDateSelected={(e: any) => {
                        handleDateMinSelected(e);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className={isTablet && isLandscape ? '' : 'rf-box__child'}>
                <div className="rf-practice-list__input-container">
                  <RfUiDatepicker
                    position={'left'}
                    moment-locale="es"
                    labelInput="Hasta"
                    text-apply-button="Aplicar"
                    // defaultDateFrom={dateMaxSelected}
                    defaultDateFrom={selectedFechaHasta}
                    defaultMinDateFrom={
                      selectedFechaDesde
                        ? selectedFechaDesde.toString()
                        : getSelectedFechaHasta().toString()
                    }
                    defaultMaxDateFrom={getSelectedFechaHasta().toString()}
                    onDateSelected={(e: any) => {
                      handleDateMaxSelected(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="rf-practice-list__input-container">
              {estadosPracticas.length > 0 && (
                <RfUiMultiselect
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  options={estadosPracticasParse}
                  text-label="Estado"
                  //defaultChecks={defaultPracticeState}
                  defaultChecksRemake={defaultPracticeState}
                  onOptionSelected={handleStatePracticeSelected}
                  placeholder="Seleccione estado"
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                options={cursos}
                defaultChecksRemake={selectedCursos}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                text-label="Curso"
                onOptionSelected={(e: any) => {
                  handleSelectedCourse(e);
                }}
                placeholder="Seleccione curso"
              />
            </div>
          </div>
          <div className="rf-box">
            {(profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611') && (
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  text-label="Sociedad"
                  options={sociedades}
                  defaultChecksRemake={selectedSociedades}
                  placeholder="Seleccione sociedad"
                  onOptionSelected={(e: any) => {
                    handleSelecteSociety(e);
                  }}
                />
              </div>
            )}
            <div className="rf-practice-list__input-container">
              {profileActive?.ID_PERFIL === '211' ? (
                <RfUiInput
                  label="Instructor"
                  value={profileActive?.ID_USUARIO + ' - ' + nombreInstructor}
                  disabled={true}
                  error=""
                  placeholder="Seleccione instructor"
                />
              ) : (
                <RfUiMultiselect
                  options={instructores}
                  defaultChecksRemake={selectedInstructores}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  onOptionSelected={handleSelectedInstructor}
                  text-label="Instructor"
                  placeholder="Seleccione instructor"
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              {profileActive?.ID_PERFIL === '111' ||
              profileActive?.ID_PERFIL === '112' ||
              profileActive?.ID_PERFIL === '121' ||
              profileActive?.ID_PERFIL === '122' ||
              profileActive?.ID_PERFIL === '123' ? (
                <RfUiInput
                  label="Alumno"
                  value={idUsuario + ' - ' + nombreUsuario}
                  disabled={true}
                  error=""
                  placeholder="Seleccione alumno"
                />
              ) : (
                <RfUiMultiselect
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  multiSelect={true}
                  options={alumnos}
                  defaultChecks={selectedAlumnos}
                  text-label="Alumno"
                  onOptionSelected={handleStudentSelected}
                  placeholder="Seleccione alumno"
                />
              )}
            </div>
            <div
              className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${
               isMobileOnly
                 ? 'rf-block--mobile rf-text-align-center--mobile'
                 : ''
             }`}
            >
              <RfUiButton
                text="Limpiar filtros"
                text-help="Limpiar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  sendToHome(false);
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Filtrar"
                type="button"
                aspect="primary"
                className="rf-button rf-margin-left-30"
                onButtonClick={() => {
                  handlerSubmitFilters();
                }}
              >
                {' '}
              </RfUiButton>
            </div>
          </div>
        </form>
      </RfUiAccordionCustom>
    </>
  );
};

export default AlumnPracticeListFilter;
